// src/data.js — Mock data for ISM dashboard.
// In production, replace these arrays with a real API call.

export const NOW = new Date('2026-05-28T10:30:00');

export const REQUEST_TYPES = [
  // Original mock types
  { id: 'access',          label: 'Access Request',   icon: 'key',       color: '#7c3aed' },
  { id: 'device',          label: 'Hardware Request', icon: 'monitor',   color: '#0891b2' },
  { id: 'software',        label: 'Software Install', icon: 'package',   color: '#0284c7' },
  { id: 'password',        label: 'Password Reset',   icon: 'lock',      color: '#ca8a04' },
  { id: 'vpn',             label: 'VPN / Network',    icon: 'globe',     color: '#0d9488' },
  { id: 'onboard',         label: 'Onboarding',       icon: 'user-plus', color: '#16a34a' },
  { id: 'offboard',        label: 'Offboarding',      icon: 'user-minus',color: '#525252' },
  // Real categories from ISM backend
  { id: 'incident',        label: 'Incident',         icon: 'alert',     color: '#e11d48' },
  { id: 'service_request', label: 'Service Request',  icon: 'package',   color: '#0284c7' },
  { id: 'access_request',  label: 'Access Request',   icon: 'key',       color: '#7c3aed' },
  { id: 'change_request',  label: 'Change Request',   icon: 'settings',  color: '#0891b2' },
  { id: 'security_alert',  label: 'Security Alert',   icon: 'alert',     color: '#dc2626' },
  { id: 'compliance',      label: 'Compliance',       icon: 'clipboard', color: '#ca8a04' },
  { id: 'problem',         label: 'Problem',          icon: 'alert',     color: '#9333ea' },
  { id: 'vendor',          label: 'Vendor',           icon: 'globe',     color: '#0d9488' },
  { id: 'internal',        label: 'Internal',         icon: 'users',     color: '#16a34a' },
  { id: 'spam',            label: 'Spam',             icon: 'x',         color: '#9ca3af' },
  { id: 'other',           label: 'Other',            icon: 'more',      color: '#525252' },
];

export const STATUSES = {
  'new':         { label: 'New',         tone: 'blue',    icon: 'plus-circle'   },
  'open':        { label: 'Open',        tone: 'indigo',  icon: 'plus-circle'   },
  'in-progress': { label: 'In Progress', tone: 'indigo',  icon: 'clock'         },
  'pending':     { label: 'Pending',     tone: 'amber',   icon: 'pause-circle'  },
  'resolved':    { label: 'Resolved',    tone: 'emerald', icon: 'check-circle'  },
  'closed':      { label: 'Closed',      tone: 'slate',   icon: 'x-circle'      },
};

export const PRIORITIES = {
  'urgent': { label: 'Urgent', tone: 'rose',  rank: 4 },
  'high':   { label: 'High',   tone: 'amber', rank: 3 },
  'medium': { label: 'Medium', tone: 'slate', rank: 2 },
  'low':    { label: 'Low',    tone: 'slate', rank: 1 },
};

// function generateRequests() {
//   const out = [];
//   const typeKeys = Object.keys(TITLES_BY_TYPE);
//   const priorityKeys = ['urgent', 'high', 'medium', 'medium', 'medium', 'low'];

//   for (let i = 0; i < 56; i++) {
//     const typeKey = typeKeys[i % typeKeys.length];
//     const titles = TITLES_BY_TYPE[typeKey];
//     const title = titles[i % titles.length];
//     const requester = REQUESTERS[(i * 7) % REQUESTERS.length];

//     let status;
//     const sMod = (i * 13) % 100;
//     if (sMod < 12)      status = 'new';
//     else if (sMod < 42) status = 'in-progress';
//     else if (sMod < 55) status = 'pending';
//     else if (sMod < 85) status = 'resolved';
//     else                status = 'closed';

//     const priority = priorityKeys[(i * 11) % priorityKeys.length];
//     const agent = AGENTS[(i * 17) % AGENTS.length];

//     const daysAgo = (i * 3) % 21;
//     const hoursAgo = (i * 5) % 24;
//     const created = new Date(NOW.getTime() - (daysAgo * 24 + hoursAgo) * 3600 * 1000);
//     const slaHours = priority === 'urgent' ? 4 : priority === 'high' ? 24 : priority === 'medium' ? 72 : 120;
//     const sla = new Date(created.getTime() + slaHours * 3600 * 1000);
//     const overdue = (status !== 'resolved' && status !== 'closed') && sla < NOW;

//     out.push({
//       id: 'ISM-' + (1240 + i).toString().padStart(4, '0'),
//       title,
//       type: typeKey,
//       status,
//       priority,
//       requester,
//       assignee: status === 'new' ? null : agent,
//       created,
//       updated: new Date(created.getTime() + ((i * 4) % 12) * 3600 * 1000),
//       sla,
//       overdue,
//       description: DESCRIPTIONS[typeKey],
//     });
//   }
//   return out;
// }

// export const REQUESTS = generateRequests();

// function computeStats() {
//   const total = REQUESTS.length;
//   const byStatus = {};
//   Object.keys(STATUSES).forEach(k => (byStatus[k] = 0));
//   REQUESTS.forEach(r => byStatus[r.status]++);

//   const open = byStatus['new'] + byStatus['in-progress'] + byStatus['pending'];
//   const overdue = REQUESTS.filter(r => r.overdue).length;

//   const trend = [];
//   for (let d = 13; d >= 0; d--) {
//     const day = new Date(NOW.getTime() - d * 24 * 3600 * 1000);
//     const created = 8 + ((d * 7) % 11);
//     const resolved = 6 + ((d * 5 + 3) % 10);
//     trend.push({ day, created, resolved });
//   }

//   const byType = {};
//   REQUEST_TYPES.forEach(t => (byType[t.id] = 0));
//   REQUESTS.forEach(r => byType[r.type]++);
//   const categoryData = REQUEST_TYPES.map(t => ({ ...t, count: byType[t.id] }));

//   const heatmap = [];
//   for (let d = 0; d < 7; d++) {
//     const row = [];
//     for (let h = 0; h < 24; h++) {
//       let v = 0;
//       if (h >= 9 && h <= 17) v = 3 + ((d * 13 + h * 7) % 8);
//       else if (h >= 7 && h <= 19) v = 1 + ((d * 5 + h * 3) % 4);
//       else v = (d * 3 + h) % 2;
//       if (d >= 5) v = Math.max(0, v - 3);
//       row.push(v);
//     }
//     heatmap.push(row);
//   }

//   return {
//     total, open, overdue,
//     avgResolutionH: 18.4,
//     slaCompliance: 87,
//     byStatus, trend, categoryData, heatmap,
//   };
// }

// export const STATS = computeStats();
